window.tpl2024 = window.tpl2024 || {};

tpl2024.config = {
	version: 'tpl2024',
	blocks : {}
};

/* article config obj
 article : {
 class           = false,
 imageRatio      = '4:3',
 imageMaxHeight  = 'none',
 imageCount      = '1',
 allowVideo      = false,
 hideHeadline    = false,
 showExcerpt     = false,
 unwrapCopy      = false,
 imageSize              : 'medium',
 imageSizes             : false,
 showImageCaptions      : false,
 clampImageCaptionLines : null,
 showBlockLabel         : false,
 showBlockRelated       : 0,     // [int] number of related stories to show, `false`=0, `true`=1
 showBlockRelatedDate   : false,
 showByline             : false,
 showReadMoreButton     : false,
 showDate               : false,  // 'modDisplay', 'modText', 'modified', 'pubDisplay', 'published'
 showDateType           : false,  // 'datetime', 'date', 'time'
 imageRequiredIn        : [0, 1], // array of article indexes, true for `all`, false for `none`
 imageNotRequiredIn     : [0, 1], // array of article indexes, true for `all`, false for `none`
 galleryAllowedIn       : [0, 1], // array of article indexes, true for `all`, false for `none`
 }
 */
tpl2024.blockDefaults = {
	id     : '',
	name   : '',
	builder: {
		show      : true,
		minColumns: 1,
		maxColumns: 3,
		options   : {}
	},
	slots  : {
		available : 1,
		requireAll: false,
		duplicates: {
			allowed: false,
			counted: true,
			ignored: false
		}
	},
	article: {
		imageRequiredIn   : [],
		imageNotRequiredIn: [],
		galleryAllowedIn  : []
	},
	on     : {
		success : null,
		complete: null
	}
};

tpl2024.config.blocks['standalone-small'] = {
	id     : 'standalone-small',
	name   : 'Small Story',
	builder: {
		options: {
			storyCount             : 4,
			allowMostPopular       : true,
			allowImageNotRequiredIn: true
		}
	},
	slots  : {},
	article: {
		imageSize      : 'thumb',
		imageSizes     : false,
		imageRequiredIn: true
	}
};

tpl2024.config.blocks['standalone-image'] = {
	id     : 'standalone-image',
	name   : 'Image Story',
	builder: {
		options: {
			storyCount      : 4,
			allowMostPopular: true
		}
	},
	slots  : {},
	article: {
		imageSize      : 'medium',
		imageSizes     : '(min-width: 1024px) 1023px, 100vw',
		imageRequiredIn: true
	}
};

tpl2024.config.blocks['standalone-overlay'] = {
	id     : 'standalone-overlay',
	name   : 'Overlay Story',
	builder: {
		options: {
			storyCount      : 4,
			allowMostPopular: true
		}
	},
	slots  : {},
	article: {
		imageSize      : 'medium',
		imageSizes     : '(min-width: 1024px) 1023px, 100vw',
		imageRequiredIn: true
	}
};

tpl2024.config.blocks['standalone-featured'] = {
	id     : 'standalone-featured',
	name   : 'Featured Story',
	builder: {
		options: {
			storyCount      : 1,
			allowMostPopular: true
		}
	},
	slots  : {},
	article: {
		imageSize      : 'medium',
		imageSizes     : '(max-width: 500px) 100vw, (max-width: 1023px) 50vw, 700px',
		imageRequiredIn: true,
		showExcerpt    : true,
		showBlockLabel : true
	}
};

tpl2024.config.blocks['standalone-text'] = {
	id     : 'standalone-text',
	name   : 'Text Story',
	builder: {
		options: {
			storyCount      : 4,
			allowMostPopular: true
		}
	},
	article: {
		imageSize : false,
		imageSizes: false
	}
};

tpl2024.config.blocks['standalone-large'] = {
	id     : 'standalone-large',
	name   : 'Large Story',
	builder: {
		options: {
			storyCount             : 4,
			allowMostPopular       : true,
			allowImageNotRequiredIn: true
		}
	},
	slots  : {},
	article: {
		imageSize      : 'small',
		imageSizes     : false,
		imageRequiredIn: true,
		showExcerpt    : true
	}
};

tpl2024.config.blocks['standalone-text-large'] = {
	id     : 'standalone-text-large',
	name   : 'Large Text Story',
	builder: {
		options: {
			storyCount      : 4,
			allowMostPopular: true
		}
	},
	article: {
		imageSize : false,
		imageSizes: false
	}
};

tpl2024.config.blocks['standalone-profile-small'] = {
	id     : 'standalone-profile-small',
	name   : 'Profile Cards',
	builder: {
		options: {
			storyCount             : 4,
			accentColor            : true,
			accentColorText        : true,
			buttonText             : 'View profile',
			allowImageNotRequiredIn: true
		}
	},
	slots  : {},
	article: {
		imageSizes     : '300px',
		imageRequiredIn: true
	}
};

tpl2024.config.blocks['cards'] = {
	id     : 'cards',
	name   : 'Story Cards',
	builder: {
		minColumns: 1,
		maxColumns: 4,
		options   : {
			storyCount      : 4,
			allowMostPopular: true
		}
	},
	slots  : {
		available: 4
	},
	article: {
		imageSize  : 'medium',
		imageSizes : false,
		showExcerpt: true
	}
};

tpl2024.config.blocks['cards-large'] = {
	id     : 'cards-large',
	name   : 'Large Story Cards',
	builder: {
		show: false
	},
	slots  : {
		available: 1
	},
	article: {
		imageRatio            : '16:9',
		imageSize             : 'large',
		imageSizes            : '(min-width: 1024px) 1023px, 100vw',
		allowVideo            : true,
		showExcerpt           : true,
		unwrapCopy            : true,
		showImageCaptions     : true,
		clampImageCaptionLines: 2,
		galleryAllowedIn      : [0],
		showBlockLabel        : true,
		showBlockRelated      : 5,
		showBlockRelatedDate  : true,
		showByline            : true,
		showDate              : 'modText,modDisplay',
		showDateType          : 'datetime',
		showReadMoreButton    : true
	}
};

tpl2024.config.blocks['special-report'] = {
	id     : 'special-report',
	name   : 'Special Report',
	builder: {
		minColumns: 1,
		maxColumns: 4,
		options   : {
			accentColor         : true,
			accentColorText     : true,
			labelText           : '',
			labelTextColor      : '#FFFFFF',
			labelBackgroundColor: true,
			allowGallery        : true
		}
	},
	slots  : {
		available : 1,
		requireAll: true,
		duplicates: {
			allowed: true
		}
	},
	article: {
		imageSize           : 'medium',
		imageSizes          : false,
		imageRequiredIn     : true,
		galleryAllowedIn    : [0],
		showExcerpt         : true,
		showBlockLabel      : true,
		showBlockRelated    : 3,
		showBlockRelatedDate: true
	}
};

tpl2024.config.blocks['impact-image'] = {
	id     : 'impact-image',
	name   : 'Impact Image',
	builder: {
		minColumns: 1,
		maxColumns: 4,
		options   : {
			allowGallery: true
		}
	},
	slots  : {
		available : 1,
		requireAll: true,
		duplicates: {
			allowed: true
		}
	},
	article: {
		imageSize       : 'large',
		imageSizes      : '(min-width: 1024px) 950px, 100vw',
		imageRequiredIn : true,
		galleryAllowedIn: [0],
		showExcerpt     : true
	}
};

tpl2024.config.blocks['impact-two-images'] = {
	id     : 'impact-two-images',
	name   : 'Impact, 2 Images',
	builder: {
		minColumns: 1,
		maxColumns: 4
	},
	slots  : {
		available : 1,
		requireAll: true
	},
	article: {
		imageSize      : 'medium',
		imageSizes     : '50vw',
		imageRequiredIn: [0],
		imageCount     : 2,
		showExcerpt    : true
	}
};

tpl2024.config.blocks['three-image'] = {
	id     : 'three-image',
	name   : '3 Images',
	builder: {
		minColumns: 1,
		maxColumns: 4,
		options   : {
			allowMostPopular: true
		}
	},
	slots  : {
		available : 3,
		requireAll: true
	},
	article: {
		imageSize      : 'large',
		imageSizes     : '(min-width: 600px) 33vw, 100vw',
		imageRequiredIn: [0, 1, 2]
	}
};

tpl2024.config.blocks['small-list'] = {
	id     : 'small-list',
	name   : 'Small List',
	builder: {
		minColumns: 1,
		maxColumns: 4,
		options   : {
			storyCount             : 4,
			allowMostPopular       : true,
			allowImageNotRequiredIn: true
		}
	},
	slots  : {
		available: 4
	},
	article: {
		imageSize : 'thumb',
		imageSizes: false
	}
};

tpl2024.config.blocks['big-video'] = {
	id     : 'big-video',
	name   : 'Big Video',
	builder: {
		minColumns: 3,
		maxColumns: 4
	},
	slots  : {
		available : 7,
		requireAll: true
	},
	article: {
		imageSize      : 'medium',
		imageSizes     : '768px',
		imageRatio     : '16:9',
		imageRequiredIn: true,
		allowVideo     : true
	},
	on     : {
		success: function(block) {
			block.on('click', '.tpl2024__big-video-videos article', function(e) {
				e.preventDefault();
				e.stopPropagation();

				const clicked = $(this);
				const parent = clicked.closest('.tpl2024__content');
				const impactVideo = parent.find('.tpl2024__big-video-impact article').first();
				const newAlternate = impactVideo.clone().hide().insertAfter(clicked);
				const newImpact = clicked.clone().hide().insertAfter(impactVideo);

				clicked.fadeOut(180, function() {
					clicked.remove();
					newAlternate.show();
				});

				impactVideo.hide(0, function() {
					impactVideo.remove();
					newImpact.show().find('.tpl2024__video-overlay').trigger('click');
				});
			});
		}
	}
};

tpl2024.config.blocks['story-list'] = {
	id     : 'story-list',
	name   : 'Story List',
	builder: {
		show: false
	},
	slots  : {
		available: 6
	},
	article: {
		imageSize  : 'large',
		imageSizes : '(min-width: 1100px) 1100px, 100vw',
		showExcerpt: true
	}
};

tpl2024.config.blocks['life-tributes'] = {
	id     : 'life-tributes',
	name   : 'Life Tributes',
	builder: {
		show: false
	},
	slots  : {
		available : 24,
		duplicates: {
			ignored: true
		}
	},
	article: {
		imageSize  : false,
		imageSizes : false,
		showExcerpt: true
	},
	on     : {
		success: function(block) {
			let legacyUrl = 'https://www.legacy.com/obituaries/pressdemocrat/';
			let placeUrl = 'https://pressdemocrat.obituaries.com?utm_campaign=consumerdirect&utm_source=sonoma&medium=np_s&utm_content=pressdemocrat';
			let learnUrl = 'https://issuu.com/smidigitaloperations/docs/brochure_11x17_4page?fr=sZmFlYTYzNDQ2ODA';

			if(cphSIT) {
				legacyUrl = 'https://www.legacy.com/obituaries/sonomanews/';
				placeUrl = 'https://sonomanews.obituaries.com?utm_campaign=consumerdirect&utm_source=sonoma&medium=np_s&utm_content=sonomanews';
			}

			if(cphPAC) {
				legacyUrl = 'https://www.legacy.com/obituaries/petaluma360/';
				placeUrl = 'https://petaluma360.obituaries.com?utm_campaign=consumerdirect&utm_source=sonoma&medium=np_s&utm_content=petaluma360';
			}

			if(cphSCG) {
				legacyUrl = 'https://www.legacy.com/us/obituaries/sonomacountygazette/';
				placeUrl = 'https://sonomacountygazette.obituaries.com?utm_campaign=consumerdirect&utm_source=sonoma&medium=np_s&utm_content=sonomacountygazette';
			}

			const buttons = $('<div/>', {
				class: 'm-t p-t b-t flex flex-wrap flex-gap',
				style: 'border-color:#CCCCCC;'
			}).appendTo(block);

			$('<a/>', {
				class: 'radius input-height button',
				href : legacyUrl,
				text : 'View all Life Tributes'
			}).appendTo(buttons);

			$('<a/>', {
				class: 'radius input-height button',
				href : placeUrl,
				text : 'Place a Life Tribute'
			}).appendTo(buttons);

			$('<a/>', {
				class: 'radius input-height button',
				href : learnUrl,
				text : 'Learn More'
			}).appendTo(buttons);
		}
	}
};

tpl2024.config.blocks['tsm'] = {
	id     : 'tsm',
	name   : 'TSM',
	builder: {
		show: false
	},
	slots  : {
		available : 10,
		requireAll: true,
		duplicates: {
			ignored: true
		}
	},
	article: {
		imageSize      : 'small',
		imageSizes     : false,
		imageRequiredIn: true
	},
	on     : {
		success: function(block) {
			block.find('article.article-0').attr('id', 'nativo2024-tsm');
		}
	}
};

window.tpl2024 = window.tpl2024 || {};

const smiBlock = window.smiBlock || {};

jQuery(function($) {
	const templateBase = (window.siteConfig && window.siteConfig.url && window.siteConfig.url.cdn) ? window.siteConfig.url.cdn + '/tpl2024/blocks' : null;
	const feedBase = feedServerUrl || 'https://api.pressdemocrat.com/get/feed.php';
	const isApiFeedBase = feedBase.indexOf('api.pressdemocrat.com') !== -1;

	const defaultImageUrl = (typeof cphDefaultImage === 'string') ? cphDefaultImage : '';

	const blockDebug = document.location.search.indexOf('blockDebug=1') !== -1;

	const sessionStorageExpireSeconds = 300; // 5 minutes

	const loadedTemplates = [];
	const feeds = {};
	const asyncQueue = [];

	let fetchingTemplates = [];
	let usedStoryUuids = [];
	let blockIncrement = 0;
	let noHeadingCount = 0;
	let prevHeading;

	smiBlock.do = function(block, blockData, onSuccess, onComplete, onFail) {
		doBlock(block, blockData, ++blockIncrement, onSuccess, onComplete, onFail);
	};

	smiBlock.get = function(parent) {
		if(!parent) parent = 'body';
		parent = $(parent);

		const els = parent.find('.tpl2024__build-block').add(parent.filter('.tpl2024__build-block')).not('.fetching').not('.tpl2024__build-block--lazy');

		els.first().each(function() {
			const block = $(this);
			const isLazy = block.data('lazy');
			if(isLazy) {
				addLazyBlock(this);
				return smiBlock.get(parent);
			}

			block.addClass('fetching');
			doBlock(block, block.data(), ++blockIncrement, function() {
				block.addClass('rendered');
			}, function() {
				smiBlock.get(parent);
			}, function() {
				block.addClass('failed');
			});
		});
	};

	smiBlock.getLazy = function(block) {
		if(!block) return;
		block = $(block);
		if(!block.length) return;
		block.removeClass('tpl2024__build-block--lazy').attr('data-lazy', '').data('lazy', false);
		smiBlock.get(block);
	};

	smiBlock.reset = function(parent) {
		if(blockDebug) console.error('BLK:', '***** RESETTING ALL BLOCKS *****');

		if(!parent) parent = 'body';
		parent = $(parent);

		const blocks = parent.find('.tpl2024__build-block');
		blocks.removeClass('fetching rendered');
		blocks.empty();

		parent.find('.sfb2024-section').data('used-stories', []);

		usedStoryUuids = [];
		blockIncrement = 0;
		noHeadingCount = 0;
		prevHeading = null;

		smiBlock.get(parent);
	};

	smiBlock.adaptImages = function(el, forceAll) {
		adaptImages(el, forceAll);
	};

	smiBlock.getFeed = function(tplBlock) {
		const cacheKey = $(tplBlock).attr('data-cache-key');
		if(!cacheKey) return {};
		if(typeof feeds[cacheKey] !== 'object') return {};
		return feeds[cacheKey];
	};

	function stretchHeadlines() {
		$('[data-stretch-headlines]').each(function() {
			const block = $(this).closest('.tpl2024__build-block, .tpl2024__block');
			stretchHeadline(block);
		});
	}

	function stretchHeadline(block) {
		block.find('[data-stretch-headlines]').each(function() {
			const headlines = $(this).find('.tpl2024__headline h3');
			let maxStretchFactor = $(this).data('stretch-headlines');

			headlines.css({
				fontSize  : '',
				lineHeight: '',
				maxHeight : ''
			});

			if(headlines.length && maxStretchFactor) {
				const growHeadlineUntilFit = function(h3, baseFontSize, iteration) {
					const fontSize = parseFloat(h3.css('font-size'));
					const lineHeight = parseFloat(h3.css('line-height'));
					const maxHeight = parseFloat(h3.css('max-height'));
					const lineHeightRatio = (lineHeight / fontSize).toFixed(3);
					const fontSizeNew = (fontSize + 1).toFixed(1);
					let headlineRows, headlineRowsNew;

					if(isNaN(maxHeight)) {
						h3.css({
							lineHeight: lineHeightRatio,
							maxHeight : 'none'
						});

						headlineRows = (h3.height() / (lineHeightRatio * fontSize)).toFixed(0);

						if(headlineRows > 1 && maxStretchFactor > 1.25)
							maxStretchFactor = 1.25;

						h3.css({fontSize: fontSizeNew + 'px'});

						headlineRowsNew = (h3.height() / (lineHeightRatio * fontSizeNew)).toFixed(0);
						if(headlineRows === headlineRowsNew) {
							if(fontSizeNew <= (baseFontSize * maxStretchFactor)) {
								return growHeadlineUntilFit(h3, baseFontSize, ++iteration);
							}
						}

						h3.css({fontSize: fontSize + 'px'});
					}
					return false;
				};

				$.each(headlines, function() {
					const h3 = $(this);
					const fontSize = parseFloat(h3.css('font-size'));
					growHeadlineUntilFit(h3, fontSize, 1);
				});
			}
		});
	}

	function adaptImages(el, forceAll) {
		if(!el) el = 'body';
		el = $(el);

		el.find('.tpl2024__image img[data-src]:visible').each(function() {
			const image = $(this);

			if(forceAll || isAboveBottomOfViewport(image)) {
				image.one('load', function() {
					image.addClass('loaded');
					$(document).trigger('tpl:imageLoaded', image);
					image.trigger('tpl:imageLoaded');
				});

				const imageSrc = image.data('src') || defaultImageUrl;
				image.attr('src', imageSrc);
				image.attr('srcset', image.data('srcset'));
				image.attr('sizes', image.data('sizes'));

				image.removeAttr('data-src');
				image.removeAttr('data-srcset');
				image.removeAttr('data-sizes');
			}
		});
	}

	function addLazyBlock(block) {
		$(block).addClass('tpl2024__build-block--lazy');
	}

	function doLazyBlocks(el) {
		if(!el) el = 'body';
		el = $(el);

		el.find('.tpl2024__build-block--lazy').add(el.filter('.tpl2024__build-block--lazy')).filter(':visible').each(function() {
			const block = $(this);
			if(isAboveBottomOfViewport(block)) {
				block.one('tpl:blockAlways', function() {
					doLazyBlocks(el);
				});
				smiBlock.getLazy(block);
				return false; // to break out of loop
			}
		});
	}

	function buildFeedVersion(feed) {
		const version = (typeof feed === 'object' && feed.version) ? feed.version : 'legacy';
		if(version !== 'tpl2024') return feed;

		const imageSrc = feed.imageSrc;
		const imageSrcCropped = feed.imageSrcCropped;

		const dateString = function(date) {
			const dateString = new Date(date).toLocaleDateString('en-us', {
				year     : 'numeric',
				month    : 'long',
				day      : 'numeric',
				hour12   : true,
				hourCycle: 'h12',
				hour     : 'numeric',
				minute   : 'numeric'
			});

			return dateString.replace(' at ', ', ').replace(' AM', 'AM').replace(' PM', 'PM');
		};

		const buildImageUrl = function(imageObj, displayWidth) {
			imageObj = imageObj || {};
			const crop = imageObj.crop || {};
			let imageWidth = displayWidth || imageObj.width;
			// also need to update whichServer in navweb://smi-site-plugin/class/Image.php
			const whichServer = imageWidth > 800 ? 'primary' : 'preview';
			if(crop && crop.ratio && crop.width && crop.x && crop.y && crop.w && crop.h) {
				const cropRatioParts = crop.ratio.split(':') || [];
				const cropRatioWidth = cropRatioParts.shift() || 0;
				const cropRatioHeight = cropRatioParts.shift() || 0;
				if(cropRatioWidth && cropRatioHeight) {
					imageWidth = Math.min(displayWidth, imageWidth, crop.width);
					const imageHeight = Math.round(imageWidth * cropRatioHeight / cropRatioWidth);
					return imageSrcCropped.replace('{{uuid}}', imageObj.uuid).replace('{{server}}', whichServer).replace('{{width}}', imageWidth)
					                      .replace('{{height}}', imageHeight).replace('{{w}}', crop.w).replace('{{h}}', crop.h).replace('{{x}}', crop.x)
					                      .replace('{{y}}', crop.y);
				}
			}

			imageWidth = Math.min(displayWidth, imageWidth);
			return imageSrc.replace('{{uuid}}', imageObj.uuid).replace('{{server}}', whichServer).replace('{{width}}', imageWidth);
		};

		const buildImageObj = function(imageObj, excludeAlt, excludeVideo) {
			const obj = {
				thumb : '',
				small : '',
				medium: '',
				large : '',
				jumbo : '',
				srcset: ''
			};

			if(!excludeAlt) {
				obj.alt = '';
				obj.caption = '';
			}

			if(!excludeVideo) {
				obj.video = {
					'href' : '',
					'embed': {
						'src'     : '',
						'autoplay': ''
					}
				};
			}

			if((typeof imageObj !== 'object') || !imageObj.uuid) return obj;

			const imageWidth = imageObj.width || 1200;
			const srcsets = [];

			obj.thumb = buildImageUrl(imageObj, 150);
			obj.small = obj.thumb;
			obj.medium = obj.thumb;
			obj.large = obj.thumb;
			obj.jumbo = obj.thumb;

			srcsets.push(obj.thumb + ' 150w');

			if(imageWidth > 150) {
				const smallWidth = Math.min(imageWidth, 300);
				obj.small = buildImageUrl(imageObj, smallWidth);
				obj.medium = obj.small;
				obj.large = obj.small;
				obj.jumbo = obj.small;
				srcsets.push(obj.small + ' ' + smallWidth + 'w');
			}

			if(imageWidth > 300) {
				const mediumWidth = Math.min(imageWidth, 768);
				obj.medium = buildImageUrl(imageObj, mediumWidth);
				obj.large = obj.medium;
				obj.jumbo = obj.medium;
				srcsets.push(obj.medium + ' ' + mediumWidth + 'w');
			}

			if(imageWidth > 768) {
				const largeWidth = Math.min(imageWidth, 1024);
				obj.large = buildImageUrl(imageObj, largeWidth);
				obj.jumbo = obj.large;
				srcsets.push(obj.large + ' ' + largeWidth + 'w');
			}

			if(imageWidth > 1024) {
				const jumboWidth = Math.min(imageWidth, 1200);
				obj.jumbo = buildImageUrl(imageObj, jumboWidth);
				srcsets.push(obj.jumbo + ' ' + jumboWidth + 'w');
			}

			obj.srcset = srcsets.join(', ');

			if(!excludeAlt) {
				obj.caption = imageObj.caption || '';
				obj.alt = imageObj.alt || obj.caption;
			}

			if(!excludeVideo) {
				const video = imageObj.video || {};
				const embed = video.embed || {};

				obj.video = {
					'href' : video.href || '',
					'embed': {
						'src'     : embed.src || '',
						'autoplay': embed.autoplay || ''
					}
				};
			}

			return obj;
		};

		feed.stories = [];
		$.each(feed.articles, function(i, article) {
			feed.stories.push({
				cmsId     : version + '-' + article.uuid,
				imageCount: article.imageCount || 0,
				href      : article.href || '',
				build     : function() {
					const images = article.images || [];
					const storyImage = buildImageObj(images[0] || {});
					const storyImages = [];
					$.each(article.images, function(j, imageObj) {
						storyImages.push(buildImageObj(imageObj));
					});

					const block = article.block || {};
					const profile = article.profile || {};
					const profileImage = buildImageObj(profile.image, true, true);

					return {
						'cmsId'      : this.cmsId,
						'uuid'       : article.uuid,
						'href'       : this.href,
						'headline'   : article.headline,
						'description': article.description,
						'byline'     : {
							'full'       : (article.byline.name + ' ' + article.byline.attribution).trim(),
							'name'       : article.byline.name,
							'attribution': article.byline.attribution
						},
						'dates'      : {
							'published'   : new Date(article.dates.published).toLocaleDateString('en-us'),
							'publishedGMT': article.dates.published,
							'modified'    : new Date(article.dates.modified).toLocaleDateString('en-us'),
							'modifiedGMT' : article.dates.modified,
							'pubDisplay'  : dateString(article.dates.published),
							'modDisplay'  : dateString(article.dates.modified),
							'modText'     : article.dates.modifiedAgo
						},
						'hasImage'   : article.images.length ? 1 : 0,
						'image'      : storyImage,
						'video'      : storyImage.video,
						'images'     : storyImages,
						'block'      : {
							'label'  : block.label || '',
							'topic'  : block.topic || '',
							'related': block.related || []
						},
						'profile'    : {
							'name'    : profile.name,
							'company' : profile.company,
							'location': profile.location,
							'image'   : profileImage
						},
						'popHits'    : article.popularHits,
						'tier'       : article.tier,
						'config'     : this.config
					};
				}
			});
		});

		return feed;
	}

	function doBlock(block, blockData, blockCount, onSuccess, onComplete, onFail) {
		if(blockDebug) console.log('BLK: ' + blockCount + ')', '*** Fetching Block', block);

		if(!block.length) return;
		if(!blockData.template) return;

		const tplSlug = blockData.template.toLowerCase();
		const tplId = '#tpl-' + tplSlug;
		const eventName = 'tpl2024:doTemplate:' + tplSlug;

		const tplConfig = $.extend(true, {}, tpl2024.blockDefaults, (tpl2024.config.blocks[tplSlug] || {}));
		const storyCount = parseInt(blockData.storyCount || tplConfig.builder.options.storyCount || tplConfig.slots.available);

		$(document).off(eventName);
		$(document).one(eventName, function() {
			const asyncItems = asyncQueue.filter(function(async) {
				return async.eventName === eventName;
			});

			asyncItems.forEach(function(asyncItem) {
				asyncItem.block.trigger(eventName);
			});
		});

		const doTemplate = function(waitOnAsync) {
			if(waitOnAsync) {
				asyncQueue.push({
					eventName : eventName,
					blockCount: blockCount,
					block     : block
				});
				block.one(eventName, function() {
					doTemplate();
				});
				return;
			}

			const templateIndex = fetchingTemplates.indexOf(tplId);
			if(templateIndex !== -1) {
				fetchingTemplates.splice(templateIndex, 1);
			}

			const isTrue = function(value) {
				const trueValues = [true, 'true', 1, '1'];
				return (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') && trueValues.indexOf(value) !== -1;
			};

			const isFalse = function(value) {
				const falseValues = [false, 'false', 0, '0']; // removed '' since that gets passed often
				return (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') && falseValues.indexOf(value) !== -1;
			};

			// if 'true', a story can be used, even if already on the page. These stories will still count as being used. Default is 'false'.
			let allowDuplicates = tplConfig.slots.duplicates.allowed || false;
			if(isTrue(blockData.allowDuplicates) || isTrue(blockData.duplicatesAllowed)) allowDuplicates = true;
			if(isFalse(blockData.allowDuplicates) || isFalse(blockData.duplicatesAllowed)) allowDuplicates = false;

			// if 'false', will not count the story as being used. Can still be excluded from a page if already used. Default is 'true'.
			let duplicatesCounted = tplConfig.slots.duplicates.counted || true;
			if(isTrue(blockData.duplicatesCounted)) duplicatesCounted = true;
			if(isFalse(blockData.duplicatesCounted)) duplicatesCounted = false;

			// if 'true', completely ignores the story as being a part of the page. Will show, even if already used and will not count story as being used.
			// Default is 'false'.
			let duplicatesIgnored = tplConfig.slots.duplicates.ignored || false;
			if(isTrue(blockData.duplicatesIgnored)) duplicatesIgnored = true;
			if(isFalse(blockData.duplicatesIgnored)) duplicatesIgnored = false;

			let imageRequiredIn = tplConfig.article.imageRequiredIn || [];
			if(blockData.imageRequiredIn !== undefined && (typeof blockData.imageRequiredIn !== 'object'))
				imageRequiredIn = blockData.imageRequiredIn;
			if(isTrue(imageRequiredIn)) imageRequiredIn = [...Array(storyCount).keys()];
			if(isFalse(imageRequiredIn)) imageRequiredIn = [];

			let imageNotRequiredIn = tplConfig.article.imageNotRequiredIn || [];
			if(blockData.imageNotRequiredIn !== undefined && (typeof blockData.imageNotRequiredIn !== 'object'))
				imageNotRequiredIn = blockData.imageNotRequiredIn;
			if(isTrue(imageNotRequiredIn)) imageNotRequiredIn = [...Array(storyCount).keys()];
			if(isFalse(imageNotRequiredIn)) imageNotRequiredIn = [];

			if(imageNotRequiredIn.length) block.addClass('tpl2024--allow-no-image');

			if(isTrue(blockData.allowGallery)) {
				let galleryAllowedIn = blockData.galleryAllowedIn || tplConfig.article.galleryAllowedIn || [];
				if(isTrue(galleryAllowedIn)) galleryAllowedIn = [...Array(storyCount).keys()];
				if(isFalse(galleryAllowedIn)) galleryAllowedIn = [];
				tplConfig.article.galleryAllowedIn = galleryAllowedIn;
			} else {
				tplConfig.article.galleryAllowedIn = [];
			}

			const showRelated = parseInt(blockData.showRelated || tplConfig.article.showBlockRelated || 0);
			if(showRelated) tplConfig.article.showBlockRelated = showRelated;

			const showDate = blockData.showDate || tplConfig.article.showDate || false;
			if(showDate) tplConfig.article.showDate = showDate;

			const showDateType = blockData.showDateType || tplConfig.article.showDateType || false;
			if(showDateType) tplConfig.article.showDateType = showDateType;

			if(isTrue(blockData.isPopular) || isTrue(blockData.isMostPopular) || isTrue(tplConfig.builder.options.isPopular)) {
				duplicatesIgnored = true;
				block.addClass('tpl2024--is-popular');
			}

			if(isTrue(blockData.thumbRight) || isTrue(tplConfig.builder.options.thumbRight)) {
				block.addClass('tpl2024--thumb-right');
			}

			if(duplicatesIgnored) {
				allowDuplicates = true;
				duplicatesCounted = false;
			}

			if(isTrue(blockData.fadeout)) block.addClass('tpl2024--fade-out');
			if(isTrue(blockData.fadeoutCopy)) block.addClass('tpl2024--fade-out-copy');
			if(isTrue(blockData.showExcerpt)) block.addClass('tpl2024--show-excerpt');
			if(isTrue(blockData.headlineTop)) block.addClass('tpl2024--headline-top');
			if(isTrue(blockData.lineBetween)) block.addClass('tpl2024--line-between');
			if(isTrue(blockData.lineAbove)) block.addClass('tpl2024--line-above');
			if(isTrue(blockData.lineBelow)) block.addClass('tpl2024--line-below');
			if(isTrue(blockData.spaceBetween)) block.addClass('tpl2024--space-between');
			if(isTrue(blockData.spaceAbove)) block.addClass('tpl2024--space-above');
			if(isTrue(blockData.spaceBelow)) block.addClass('tpl2024--space-below');

			if(blockData.storyType !== undefined) block.addClass('tpl2024--' + blockData.storyType);

			let cacheKey;
			let heading;
			let subheading;

			function successHandler(data) {
				let tpl = getTemplate(data);
				let tplHeader;
				let tplStoryMap;

				if(tpl === false) {
					failHandler();
					return;
				}

				tpl = $(tpl);

				// move any modifier classes to 'tpl' rather than 'block'
				$.each(block.prop('className').split(' '), function(i, className) {
					if(className.match(/^tpl2024--/)) {
						block.removeClass(className);
						tpl.addClass(className);
						if(blockDebug) console.log('BLK: ' + blockCount + ')', 'CHANGE: class ' + className + ' moved from block to tpl');
					}
				});

				block.attr('data-cache-key', cacheKey);
				block.html(tpl);

				const articles = tpl.find('article');
				tpl.attr('data-article-count', articles.length);
				tpl.attr('data-article-parity', articles.length % 2 === 0 ? 'even' : 'odd');
				tpl.attr('data-article-fours', articles.length % 4 === 0 ? 'true' : 'false');
				tpl.attr('data-article-threes', articles.length % 3 === 0 ? 'true' : 'false');
				tpl.attr('data-article-twos', articles.length % 2 === 0 ? 'true' : 'false');

				if(blockData.articleClass) articles.addClass(blockData.articleClass);

				tpl2024.buildArticles(block);

				if(imageNotRequiredIn.length) {
					articles.each(function(i, article) {
						if(imageNotRequiredIn.indexOf(i) !== -1) {
							article = $(article);
							const emptyImages = article.find('img[data-src=""]');
							if(emptyImages.length) {
								emptyImages.closest('.tpl2024__image').remove();
								article.addClass('tpl2024--has-no-image');
							}
						}
					});
				}

				let accentColor;
				if(blockData.accentColor === undefined) {
					accentColor = tplConfig.builder.options.accentColor || null;
				} else {
					accentColor = blockData.accentColor;
				}

				if(accentColor && !isTrue(accentColor) && !isFalse(accentColor))
					tpl.css('--tpl-accent-color', accentColor);

				let accentColorText;
				if(blockData.accentColorText === undefined) {
					accentColorText = tplConfig.builder.options.accentColorText || null;
				} else {
					accentColorText = blockData.accentColorText;
				}
				if(accentColorText && !isTrue(accentColorText) && !isFalse(accentColorText))
					tpl.css('--tpl-accent-color-text', accentColorText);

				let buttonText;
				if(blockData.buttonText === undefined) {
					buttonText = tplConfig.builder.options.buttonText || null;
				} else {
					buttonText = blockData.buttonText;
				}

				if(buttonText) {
					block.one('tpl:blockLoaded', function() {
						block.find('.tpl2024__update-button-text').text(buttonText);
					});
				}

				tplHeader = block.find('.tpl2024__heading');

				if(tplHeader.length) {
					if(heading) {
						noHeadingCount = 0;

						tpl.addClass('tpl2024--has-heading');

						if(data && typeof data.link !== 'undefined' && data.link.url) {
							heading = $('<a />', {
								target: '_self',
								href  : data.link.url,
								html  : heading
							});
						}

						const headingHtml = [];

						headingHtml.push(
							$('<span/>', {
								html: heading
							})
						);

						if(subheading) {
							headingHtml.push(
								$('<small/>', {
									html: subheading
								})
							);
						}

						tplHeader.html(headingHtml);
					} else {
						noHeadingCount++;
						tpl.addClass('tpl2024--no-heading tpl2024--no-heading-' + noHeadingCount);
						tplHeader.remove();
					}
				}

				tplStoryMap = block.find('.has-size-map');
				if(tplStoryMap.length) {
					$.each(tplStoryMap, function() {
						const storyBlock = $(this);
						const breakpoints = storyBlock.data('size-map');
						if(breakpoints) {
							resizeStories(storyBlock, breakpoints);
							$(document).on('tpl:resizeStories', function() {
								resizeStories(storyBlock, breakpoints);
							});
						}
					});
				}

				setTimeout(function() {
					stretchHeadline(block);
					adaptImages(block);

					if(typeof tplConfig.on.success === 'function') {
						tplConfig.on.success(block);
					}
					if(typeof blockData.onsuccess !== 'undefined' && (typeof window[blockData.onsuccess] === 'function')) {
						window[blockData.onsuccess](block);
					}
					if(typeof onSuccess === 'function') {
						onSuccess(block);
					}

					$(document).trigger('tpl:blockLoaded', block);
					block.trigger('tpl:blockLoaded');
				});
			}

			function alwaysHandler() {
				if(typeof tplConfig.on.complete === 'function') {
					tplConfig.on.complete(block);
				}

				if(typeof blockData.oncomplete !== 'undefined' && (typeof window[blockData.oncomplete] === 'function')) {
					window[blockData.oncomplete](block);
				}

				if(typeof onComplete === 'function') {
					onComplete(block);
				}

				setTimeout(function() {
					$(document).trigger('tpl:blockAlways', block);
					block.trigger('tpl:blockAlways');
				});
			}

			function failHandler() {
				if(typeof tplConfig.on.fail === 'function') {
					tplConfig.on.fail(block);
				}

				if(typeof blockData.onfail !== 'undefined' && (typeof window[blockData.onfail] === 'function')) {
					window[blockData.onfail](block);
				}

				if(typeof onFail === 'function') {
					onFail(block);
				}

				setTimeout(function() {
					$(document).trigger('tpl:blockFailed', block);
					block.trigger('tpl:blockFailed');
				});
			}

			function resizeStories(storyBlock, breakpoints) {
				const outerWidth = Math.round(storyBlock.closest('.tpl2024__block').width());
				$.each(breakpoints, function(width, className) {
					if(outerWidth >= width) {
						storyBlock.removeClass().addClass('has-size-map').addClass(className);
						const baseClass = storyBlock.data('base-class');
						if(baseClass) storyBlock.addClass(baseClass);
					}
				});
			}

			function getTemplate(data) {
				if(loadedTemplates[tplId] === undefined) {
					const tplHtml = $(tplId).html();
					if(tplHtml) {
						loadedTemplates[tplId] = Template7(tplHtml).compile();
					} else {
						loadedTemplates[tplId] = false;
					}

					if(blockDebug) {
						if(typeof loadedTemplates[tplId] === 'function') {
							console.log('BLK: ' + blockCount + ')', 'Template compiled', loadedTemplates[tplId]);
						} else {
							console.error('BLK: ' + blockCount + ')', 'TEMPLATE FAILED: Unable to compile template');
						}
					}
				}

				if(loadedTemplates[tplId]) {
					data = buildFeedVersion(data);

					const tplData = {};
					tplData.version = data.version || 'legacy';
					tplData.imageSrc = data.imageSrc || null;
					tplData.imageSrcCropped = data.imageSrcCropped || null;

					tplData.stories = filterStories(data.stories);

					if(!tplData.stories.length) {
						if(blockDebug) console.error('BLK: ' + blockCount + ')', 'RENDERING FAILED: No stories found');
						return false;
					}

					if(tplData.stories.length !== storyCount && tplConfig.slots.requireAll !== false) {
						if(blockDebug) console.error('BLK: ' + blockCount + ')', 'RENDERING FAILED: ' + tplData.stories.length + ' of ' + storyCount + ' required stories');
						return false;
					}

					tplData.stories.forEach(function(story) {
						story.config = tplConfig.article || {};
					});

					return loadedTemplates[tplId](tplData);
				}

				return false;
			}

			function filterStories(stories) {
				const usedStories = [];
				const parentSection = block.closest('.sfb2024-section');
				let sectionUsedStories = [];
				if(parentSection.is(smiBlock.lastParentSection))
					sectionUsedStories = parentSection.data('used-stories') || [];
				let filteredStories = stories;

				smiBlock.lastParentSection = parentSection;

				if(!filteredStories || !filteredStories.length) return false;

				if(!duplicatesIgnored) {
					if(!allowDuplicates) {
						filteredStories = stories.filter(function(story) {
							return $.inArray(story.cmsId, usedStoryUuids) === -1;
						});
					} else if(parentSection.length) {
						filteredStories = stories.filter(function(story) {
							return $.inArray(story.cmsId, sectionUsedStories) === -1;
						});
					}
				}

				const shuffleForImageRequired = function(iteration, trialCount) {
					if(!trialCount) trialCount = 0;
					const storyObj = filteredStories[0];
					const storyImage = storyObj.image || {};
					const storyHasImage = !!(storyObj.imageCount || storyImage.thumb);

					if(storyObj && storyHasImage) {
						if($.inArray(iteration, imageRequiredIn) !== -1 && !storyHasImage) {
							trialCount = (trialCount + 1);
							if(trialCount < filteredStories.length) {
								filteredStories.splice(0, 0, filteredStories.splice(trialCount, 1)[0]);
								return shuffleForImageRequired(iteration, trialCount);
							}
						}
					}

					return filteredStories.shift();
				};

				filteredStories = filteredStories.slice(0, storyCount);

				const storyTotal = filteredStories.length;
				for(let i = 0; i < storyTotal; i++) {
					const storyObj = shuffleForImageRequired(i);
					if(storyObj && storyObj.cmsId) {
						if(!duplicatesIgnored && duplicatesCounted) {
							usedStoryUuids.push(storyObj.cmsId);
							sectionUsedStories.push(storyObj.cmsId);
						}
						usedStories.push(storyObj);
					}
				}

				parentSection.data('used-stories', sectionUsedStories);

				if(blockData.ref) {
					$.each(usedStories, function(i, usedStory) {
						if(usedStory.href)
							usedStory.href = updateQueryStringParameter('ref', blockData.ref, usedStory.href);
						usedStories[i] = usedStory;
					});
				}

				return usedStories;
			}

			if(!tplConfig.id) {
				console.error('BLK: ' + blockCount + ')', 'NO CONFIG:   ' + tplId);
				alwaysHandler();
				failHandler();
				return;
			}

			if(blockDebug) console.log('BLK: ' + blockCount + ')', 'TEMPLATE:    ' + tplId);
			heading = blockData.heading || false;
			subheading = blockData.subheading || false;

			if(heading === prevHeading && block.prev().is('.tpl2024__build-block')) {
				heading = false;
			} else {
				prevHeading = heading;
			}

			const tplRequest = getTplRequest(blockData.path);
			const tplDataSrc = tplRequest.src;
			const tplData = tplRequest.data;

			if(!tplDataSrc) {
				console.error('BLK: ' + blockCount + ')', 'DATA ERROR: unable to fetch data. No feed path defined.', block);
				alwaysHandler();
				failHandler();
				return false;
			}

			if(blockDebug) console.log('BLK: ' + blockCount + ')', 'SRC:         ' + tplDataSrc);

			cacheKey = hashedUrl(tplDataSrc);

			if(tplData) {
				if(blockDebug) console.log('BLK: ' + blockCount + ')', 'DATA FROM:   on page variable');
				successHandler(tplData);
				alwaysHandler();
				return true;
			}

			if(typeof feeds[cacheKey] === 'object') {
				if(blockDebug) console.log('BLK: ' + blockCount + ')', 'DATA FROM:   stored feed object');
				successHandler(feeds[cacheKey]);
				alwaysHandler();
				return true;
			}

			if(window.sessionStorage) {
				try {
					const cachedData = sessionStorage.getItem(cacheKey);
					const timeCached = sessionStorage.getItem(cacheKey + ':ts');

					if(cachedData && timeCached) {
						const sessionStorageAgeSeconds = (Date.now() - timeCached) / 1000;
						if(sessionStorageAgeSeconds < sessionStorageExpireSeconds) {
							const sessionStorageData = JSON.parse(cachedData);
							if(typeof sessionStorageData === 'object') {
								if(blockDebug) console.log('BLK: ' + blockCount + ')', 'DATA FROM:   session storage');
								feeds[cacheKey] = sessionStorageData;
								successHandler(sessionStorageData);
								alwaysHandler();
								return true;
							}
						} else {
							sessionStorage.removeItem(cacheKey);
							sessionStorage.removeItem(cacheKey + ':ts');
						}
					}
				} catch(e) {
					if(blockDebug) console.error('BLK: ' + blockCount + ')', 'Fetching from sessionStorage failed:', e);
				}
			}

			if(tplDataSrc.indexOf('http') === 0) {
				const request = $.ajax({
					dataType: 'json',
					url     : tplDataSrc,
					timeout : 6000
				});

				request.done(function(data) {
					feeds[cacheKey] = data;

					if(window.sessionStorage) {
						try {
							sessionStorage.setItem(cacheKey, JSON.stringify(data));
							sessionStorage.setItem(cacheKey + ':ts', Date.now().toString());
						} catch(e) {
							sessionStorage.clear();
							if(blockDebug) console.error('BLK: ' + blockCount + ')', 'Saving to sessionStorage failed:', e);
						}
					}

					if(blockDebug) console.log('BLK: ' + blockCount + ')', 'DATA FROM:   $.getJSON()');
					successHandler(data);
				});

				request.always(function() {
					alwaysHandler();
				});

				request.fail(function() {
					if(blockDebug) console.error('BLK: ' + blockCount + ')', 'JSON ERROR: failed to fetch ' + tplDataSrc);
					failHandler();
				});
			} else {
				console.error('BLK: ' + blockCount + ')', 'DATA ERROR: no way to fetch data for ' + tplDataSrc + '. It may be empty or it may not exist.');
				alwaysHandler();
				failHandler();
			}
		};

		const fetchTemplate = function() {
			if(fetchingTemplates.indexOf(tplId) === -1) {
				fetchingTemplates.push(tplId);

				if(!(tpl2024.config.blocks[tplSlug] || null))
					return doTemplate(); // no config, so nothing to fetch or render

				if($('script' + tplId).length)
					return doTemplate(); // template is already rendered in HTML, so no need to fetch

				if(!templateBase)
					return doTemplate(); // url to fetch templates from not defined

				if(blockDebug) console.log('BLK: ' + blockCount + ')', 'Fetching Template: (' + tplSlug + ')');

				const request = $.get(templateBase + '/' + tplSlug + '.html');

				request.done(function(data) {
					if(blockDebug) console.log('BLK: ' + blockCount + ')', 'Template Fetched: (' + tplSlug + ')');
					$('body').append(data);
					$(document).trigger(eventName);
				});

				request.fail(function() {
					if(blockDebug) console.error('BLK: ' + blockCount + ')', 'Template Failed: (' + tplSlug + ')');
					$(document).trigger(eventName);
				});
			}

			return doTemplate(true);
		};

		fetchTemplate();
	}

	function parseFeedPath(feedPath) {
		if(feedPath.indexOf('http') === 0) return feedPath;
		feedPath = feedPath.toLowerCase().replace(/^\/+|\/+$/g, ''); // remove leading and trailing slashes

		const pathParts = feedPath.split('/');
		const feedPub = pathParts.shift();

		let feedUrl;
		switch(feedPub) {
			case 'pd':
				feedUrl = 'https://www.pressdemocrat.com/smi/feeds/json';
				break;
			case 'sit':
				feedUrl = 'https://www.sonomanews.com/smi/feeds/json';
				break;
			case 'pac':
				feedUrl = 'https://www.petaluma360.com/smi/feeds/json';
				break;
			case 'nbbj':
				feedUrl = 'https://www.northbaybusinessjournal.com/smi/feeds/json';
				break;
			case 'lps':
				feedUrl = 'https://www.laprensasonoma.com/smi/feeds/json';
				break;
			case 'scg':
				feedUrl = 'https://www.sonomacountygazette.com/smi/feeds/json';
				break;
			default:
				// put back together and return if not naviga pub
				return feedPub + '/' + pathParts.join('/');
		}

		const feedType = pathParts.shift();
		feedPath = pathParts.join('/');

		const feedPathBits = feedPath.split('|||');
		const feedValue = feedPathBits.shift() || '';
		const ippParts = (feedPathBits.shift() || '').split('/');
		const feedIpp = ippParts.shift();
		const feedPage = ippParts.shift();

		const feedValueEncoded = feedValue;

		switch(feedType) {
			case 'list':
				feedUrl += '/list/?name=' + feedValueEncoded;
				break;
			case 'section':
				feedUrl += '/section/?path=' + feedValueEncoded;
				break;
			case 'popular':
				feedUrl += '/popular/?name=' + feedValueEncoded;
				break;
			case 'topic':
				feedUrl += '/topic/?t=' + feedValueEncoded;
				break;
			case 'profile':
				feedUrl += '/profile/?t=' + feedValueEncoded;
				break;
			case 'type':
				feedUrl += '/type/?type=' + feedValueEncoded;
				break;
			case 'recent':
				feedUrl += '/recent/?ipp=' + feedValueEncoded;
				break;
			case 'private':
				feedUrl += '/private/?ipp=' + feedValueEncoded;
				break;
			case 'article':
				if(feedValue.length === 36) {
					if(feedValue.match(/^s*[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}s*$/i)) {
						feedUrl += 'article/?uuid=' + feedValueEncoded;
						break;
					}
				}
				feedUrl += '/article/?slug=' + feedValueEncoded;
				break;
			default:
				// put back together and return if not valid feedType
				feedPath = feedPub + '/' + feedType + '/' + feedValue;
				if(feedIpp) {
					feedPath += '|||' + feedIpp;
					if(feedPage) feedPath += '/' + feedPage;
				}
				return feedPath;
		}

		if(feedIpp) feedUrl += '&ipp=' + feedIpp;

		if(feedPage) feedUrl += '&pg=' + feedPage;

		feedUrl += '&isTpl2024=1';

		return feedUrl;
	}

	function getTplRequest(feedPath) {
		feedPath = feedPath || '';
		let feedSrc = '';
		if(feedPath.indexOf('/') === -1 && window[feedPath]) {
			// if on-page variable
			return {
				src : feedPath,
				data: window[feedPath]
			};
		}

		feedPath = parseFeedPath(feedPath);
		if(feedPath.indexOf('http') === 0) {
			// if http(s) defined in path
			feedSrc = feedPath;
		} else if(feedPath && feedBase) {
			const feedPathBits = feedPath.split('|||');
			feedPath = feedPathBits.shift();

			if(isApiFeedBase) {
				let ipp = feedPathBits.shift() || '25';
				let ippParts = ipp.split('/');
				ipp = parseInt(ippParts.shift() || '25');
				const page = parseInt(ippParts.shift()) || 1;

				// get from API feeds server
				feedSrc = feedBase + '?path=' + feedPath + '&isTpl2024=1&ipp=' + ipp + '&pg=' + page;
			} else {
				// look on feeds server
				feedSrc = feedBase + '/' + feedPath + '.json';
			}
		}

		return {
			src : feedSrc,
			data: null
		};
	}

	function hashedUrl(url) {
		let hash = 0, i;
		if(url.length === 0) return hash;
		for(i = 0; i < url.length; i++) {
			const char = url.charCodeAt(i);
			hash = ((hash<<5) - hash) + char;
			hash = hash&hash;
		}
		return hash;
	}

	function isAboveBottomOfViewport(el) {
		return $(el).offset().top < ($(window).scrollTop() + $(window).height());
	}

	function updateQueryStringParameter(key, value, url) {
		if(!url) url = window.location.href;

		const i = url.indexOf('#');
		const hash = i === -1 ? '' : url.substring(i);
		url = i === -1 ? url : url.substring(0, i);

		const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		const separator = url.indexOf('?') !== -1 ? '&' : '?';
		if(value === false) {
			if(url.match(re)) {
				url = url.replace(re, '$1');
			}
		} else {
			if(url.match(re)) {
				url = url.replace(re, '$1' + key + '=' + value + '$2');
			} else {
				url = url + separator + key + '=' + value;
			}
		}
		url = url.replace(/([?&]+)$/, ''); // added to remove ? or & at end of url if present
		return url + hash;
	}

	$(document).on('ajaxStart.tpl2024', function() {
		let asInt = setInterval(function() {
			if(!$.active) {
				$(document).off('ajaxStart.tpl2024');
				clearInterval(asInt);
				setTimeout(function() {
					$(document).trigger('tpl:jsonLoaded');
				}, 250);
			}
		}, 150);
	});

	let resizeTimer; // debounced
	$(window).on('resize orientationchange', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			$(document).trigger('tpl:resizeStories');
			doLazyBlocks();
			stretchHeadlines();
			adaptImages();
		}, 250);
	});

	let wait; // throttled
	$(window).on('scroll', function() {
		if(!wait) {
			wait = true;
			setTimeout(function() {
				wait = false;
				doLazyBlocks();
				adaptImages();
			}, 250);
		}
	});
});
window.tpl2024 = window.tpl2024 || {};

(function($) {
	tpl2024.articles = [];
	let articleKey = 0;

	function buildArticle(story, options) {
		if(typeof story.build === 'function') story = story.build();

		const idx = options.data.index;
		const config = $.extend(true, {}, options.hash || {}, story.config || {});
		const imageCount = parseInt(config.imageCount) || 1;
		const articleClasses = [];
		let totalImages = 0;
		let imageHtml = '';
		articleKey++;

		tpl2024.articles[articleKey] = story;

		articleClasses.push('article article-' + idx);
		if(options.data.first) articleClasses.push('article-first');
		if(options.data.last) articleClasses.push('article-last');
		if(config.class) articleClasses.push(config.class);

		if(!imageCount) {
			imageHtml += buildImage(story, 0, options);
		} else {
			for(let imageNum = 0; imageNum < imageCount; imageNum++) {
				const thisImage = buildImage(story, imageNum, options);
				if(thisImage) {
					imageHtml += thisImage;
					totalImages++;
				}
			}
		}

		const articleAtts = [
			'class="' + articleClasses.join(' ') + '"',
			'data-uuid="' + esc(story.uuid) + '"',
			'data-tier="' + esc(story.tier) + '"',
			'data-article-key="' + articleKey + '"'
		];

		if(config.imageRatio && config.imageRatio !== '4:3') {
			const pcs = config.imageRatio.split(':');
			const w = parseInt(pcs.shift());
			const h = parseInt(pcs.shift());

			if(!(isNaN(w) || isNaN(h))) {
				const paddingBottom = ((h / w) * 100).toFixed(2) + '%';
				articleAtts.push('style="--tpl-image-padding-bottom:' + paddingBottom + ';"');
			}
		}

		let html = '<article ' + articleAtts.join(' ') + '>';

		html += '<div class="tpl2024__wrap" data-image-count="' + totalImages + '">';
		html += imageHtml;
		html += buildCopy(story, options);
		html += '</div>';
		html += '</article>';

		return html;
	}

	function buildImage(story, imageNum, options) {
		if(typeof story.build === 'function') story = story.build();

		const config = $.extend(true, {}, options.hash || {}, story.config || {});
		if(!story || isFalse(config.imageSize)) return '';

		const images = story.images || [];
		let image = {};
		let video = {};

		if(typeof images[imageNum] === 'object') {
			image = images[imageNum];
			video = images[imageNum].video || {};
		} else if(imageNum === 0) {
			image = story.image || {};
			video = story.video || {};
		}

		config.imageSize = image[config.imageSize] ? config.imageSize : 'large';
		const src = image[config.imageSize] || '';
		if(!src && imageNum > 0) return '';

		config.imageSizes = config.imageSizes || false;
		config.imageRatio = config.imageRatio || '4:3';
		config.allowVideo = isTrue(config.allowVideo);
		config.imageMaxHeight = config.imageMaxHeight || false;

		const imgAtts = [];
		imgAtts.push('src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"');
		imgAtts.push('data-src="' + esc(src) + '"');
		imgAtts.push('data-size="' + esc(config.imageSize) + '"');
		imgAtts.push('data-uuid="' + esc(story.uuid) + '"');
		if(image.srcset && config.imageSizes) {
			imgAtts.push('data-srcset="' + esc(image.srcset) + '"');
			imgAtts.push('data-sizes="' + esc(config.imageSizes) + '"');
		}
		imgAtts.push('alt="' + esc(image.alt || image.caption || '') + '"');
		imgAtts.push('data-caption="' + esc(image.caption || '') + '"');

		if(config.galleryAllowedIn && config.galleryAllowedIn.length && config.galleryAllowedIn.includes(options.data.index)) {
			imgAtts.push('data-gallery-size="' + esc(config.imageSize) + '"');
			imgAtts.push('data-gallery-uuid="' + esc(story.uuid) + '"');
		}

		let hasMaxHeight = '';
		if(config.imageMaxHeight) hasMaxHeight = ' style="max-height: ' + config.imageMaxHeight + ';"';

		let html = '<div class="tpl2024__image tpl2024__image-' + imageNum + '" data-article-num="' + (options.data.index + 1) + '" data-image-num="' + (imageNum + 1) + '"' + hasMaxHeight + '>';

		if(config.allowVideo && video.embed.src) {
			html += '<iframe src="" data-src="' + esc(video.embed.autoplay || video.embed.src) + '" width="100%" allowFullScreen>Your browser does not support iframes</iframe>';
			html += '<div class="tpl2024__video-overlay">';
			html += '<img src="https://img.pressdemocrat.com/shared/play-button.png" alt="play video" height="150" width="150">';
			html += '</div>';
		}

		html += '<a href="' + story.href + '" aria-label="' + esc(story.headline) + '" tabindex="-1">';
		html += '<img ' + imgAtts.join(' ') + '>';
		html += '</a>';

		if(isTrue(config.showImageCaptions)) {
			html += '<div class="tpl2024__image-caption" data-clamp-caption="' + (config.clampImageCaptionLines || '') + '">';
			html += esc(image.caption);
			html += '</div>';
		}

		html += '</div>';

		return html;
	}

	function buildCopy(story, options) {
		if(typeof story.build === 'function') story = story.build();

		const config = $.extend(true, {}, options.hash || {}, story.config || {});

		let html = '';
		if(!isTrue(config.unwrapCopy)) html += '<div class="tpl2024__copy">';

		// do not make .tpl2024__label a config item since it does get used for the search page to show the date.
		html += '<div class="tpl2024__label" data-fetch-label="' + JSON.stringify(isTrue(config.showBlockLabel)) + '"></div>';

		if(config.showDate) {
			const showDateType = config.showDateType || '';
			html += '<div class="tpl2024__updated" data-show-date="' + config.showDate + '" data-show-date-type="' + showDateType + '"></div>';
		}

		if(!isTrue(config.hideHeadline)) {
			html += '<div class="tpl2024__headline" data-article-num="' + (options.data.index + 1) + '">';
			html += '<h3 data-article-num="' + (options.data.index + 1) + '">';
			html += '<a href="' + esc(story.href) + '">';
			html += esc(story.headline);
			html += '</a>';
			html += '</h3>';
			html += '</div>';
		}

		if(isTrue(config.showByline) && story.byline.full) html += '<div class="tpl2024__byline">' + esc(story.byline.full) + '</div>';

		if(isTrue(config.showExcerpt)) {
			html += '<div class="tpl2024__excerpt">';
			html += '<p>';
			html += esc(story.description);
			html += '</p>';
			html += '</div>';
		}

		if(isTrue(config.showReadMoreButton)) html += '<div class="tpl2024__read-more"><a href="' + esc(story.href) + '">Read the full story</a></div>';

		if(config.showBlockRelated > 0) { // because related come through via blockItems
			html += '<ul class="tpl2024__related" data-fetch-related="' + config.showBlockRelated + '" data-show-related-date="' + JSON.stringify(isTrue(config.showBlockRelatedDate)) + '"></ul>';
		}

		if(!isTrue(config.unwrapCopy)) html += '</div>';
		return html;
	}

	function buildProfile(story, options) {
		if(typeof story.build === 'function') story = story.build();

		const idx = options.data.index;
		const config = $.extend(true, {}, options.hash || {}, story.config || {});
		const articleClasses = [];

		articleClasses.push('article article-' + idx);
		if(options.data.first) articleClasses.push('article-first');
		if(options.data.last) articleClasses.push('article-last');
		if(config.class) articleClasses.push(config.class);

		config.imageSizes = config.imageSizes || '100vw';

		const articleAtts = [
			'class="' + articleClasses.join(' ') + '"',
			'data-uuid="' + esc(story.uuid) + '"',
			'data-tier="' + esc(story.tier) + '"'
		];

		let html = '<article ' + articleAtts.join(' ') + '>';

		const profile = story.profile || {};
		const profileImage = profile.image || {};

		html += '<div class="tpl2024__wrap" data-image-count="1">';

		html += '<div class="tpl2024__image">';
		html += '<a target="' + esc(story.hrefTarget) + '" href="' + esc(story.href) + '">';
		html += '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src="' + esc(profileImage.small) + '" data-size="small" data-uuid="' + esc(story.uuid) + '" data-srcset="' + esc(profileImage.srcset) + '" data-sizes="' + esc(config.imageSizes) + '" alt="' + esc(profile.name) + '">';
		html += '</a>';
		html += '</div>';

		html += '<div class="tpl2024__copy">';
		html += '<div class="tpl2024__info">';
		html += '<h3>' + esc(profile.name) + '</h3>';
		html += '<p>' + esc(profile.company) + '</p>';
		html += '<p>' + esc(profile.location) + '</p>';
		html += '</div>';
		html += '<div class="tpl2024__cta">';
		html += '<a class="tpl2024__update-button-text" target="' + esc(story.hrefTarget) + '" href="' + esc(story.href) + '">View Profile</a>';
		html += '</div>';
		html += '</div>';

		html += '</div>';
		html += '</article>';

		return html;
	}

	function esc(html, preserveCR) {
		preserveCR = preserveCR ? '&#13;' : '\n';
		if(!html) return '';

		return html.toString()
		           .replace(/&/g, '&amp;')
		           .replace(/'/g, '&apos;')
		           .replace(/"/g, '&quot;')
		           .replace(/</g, '&lt;')
		           .replace(/>/g, '&gt;')
		           .replace(/\r\n/g, preserveCR) // Must be before the next replacement.
		           .replace(/[\r\n]/g, preserveCR);
	}

	function isTrue(value) {
		const trueValues = [true, 'true', 1, '1'];
		return (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') && trueValues.indexOf(value) !== -1;
	}

	function isFalse(value) {
		const falseValues = [false, 'false', 0, '0']; // removed '' since that gets passed often
		return (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') && falseValues.indexOf(value) !== -1;
	}

	function doImageGalleries(block) {
		block.find('.tpl2024__image img[gallery-uuid!=""]').each(function() {
			const image = $(this);
			image.one('tpl:imageLoaded', function() {
				const uuid = image.data('gallery-uuid');
				const size = image.data('gallery-size');
				if(!uuid || !uuid) return; // if size or uuid not set, we can't proceed

				const article = image.closest('article');
				const isVideo = article.find('.tpl2024__video-overlay').length;
				if(isVideo) return; // no slideshow if first slide is a video

				const wrap = image.closest('a');
				if(!wrap.length) return; // if not present, this won't work

				const sizes = image.attr('sizes') || '100vw';
				const caption = article.find('.tpl2024__image-caption');

				// Get image object from feed server. This means that this will only work for Naviga publications
				var json = $.getJSON('/smi/feeds/json/images/?uuid=' + uuid + '&size=' + size);
				json.done(function(data) {
					var validImages = [];
					$.each(data.images, function(i, image) {
						if(image.video.id) return; // exclude videos
						if(image.image.orientation !== 'horizontal') return; // exclude portrait images
						validImages.push(image);
					});

					if(validImages.length <= 1) return;

					var sContainer = $('<div class="swiper-container"/>'),
						sWrapper = $('<div class="swiper-wrapper"/>'),
						sSlide = $('<div class="swiper-slide"/>'),
						sImg = $('<img class="swiper-lazy"/>'),
						sPl = $('<div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>'),
						slides = [];

					sContainer.css({
						position  : 'absolute',
						width     : '100%',
						height    : '100%',
						background: '#777777'
					});

					sImg.css({
						color    : 'transparent',
						objectFit: 'cover'
					});

					$.each(validImages, function(i, obj) {
						var img = obj.image, thisImg = sImg.clone(), thisSlide = sSlide.clone();

						thisImg.attr('sizes', sizes);
						thisImg.attr('alt', img.alt || img.caption || '');
						thisImg.attr('data-caption', img.caption || '');

						if(i === 0) { // first slide
							thisImg.attr('src', img.href);
							thisImg.attr('srcset', img.srcset);
							thisImg.removeClass('swiper-lazy');

							thisSlide.html(thisImg);
						} else {
							thisImg.attr('data-src', img.href);
							thisImg.attr('data-srcset', img.srcset);

							thisSlide.html([thisImg, sPl.clone()]);
						}

						slides.push(thisSlide);
					});

					if(slides.length) {
						sWrapper.html(slides);
						sContainer.html(sWrapper);
						wrap.html(sContainer);

						const rotateCaption = function() {
							if(!caption.length) return;
							const activeSlide = sContainer.find('.swiper-slide-active');
							caption.html(activeSlide.find('img:first').data('caption') || '');
						};

						cphLoader.loadSwiper(function() {
							new Swiper(sContainer[0], {
								navigation    : false,
								allowTouchMove: false,
								autoplay      : {
									delay            : 4000,
									pauseOnMouseEnter: true
								},
								preloadImages : false,
								lazy          : {
									loadPrevNext: true
								},
								effect        : 'fade',
								loop          : true,
								slidesPerView : 1,
								on            : {
									afterInit                 : rotateCaption,
									slideChangeTransitionStart: rotateCaption
								}
							});
						});
					}
				});
			});
		});
	}

	function doArticleLabels(block) {
		block.find('div.tpl2024__label[data-fetch-label="true"]').each(function() {
			const label = $(this);
			const article = label.closest('article');
			const blockItems = tpl2024.getBlockItems(article);
			const labelText = block.data('label-text') || blockItems.label;
			const labelTextColor = block.data('label-text-color');
			const labelBackgroundColor = block.data('label-background-color');

			if(labelText) {
				const labelSpan = $('<span/>').html(labelText);
				if(labelTextColor) labelSpan.css('color', labelTextColor);
				if(labelBackgroundColor) labelSpan.css({
					display        : 'inline-block',
					padding        : '.15em .3em',
					backgroundColor: labelBackgroundColor
				});

				label.html(labelSpan);
			}
		});
	}

	function doDateUpdated(block) {
		block.find('div.tpl2024__updated[data-show-date!=""]').each(function() {
			const el = $(this);
			const article = el.closest('article');
			const data = tpl2024.getStoryObject(article);
			if(!data || !data.dates) return;

			const dateOptions = el.data('show-date').split(',');
			$.each(dateOptions, function() {
				let date = data.dates[this];
				if(!date) return true;

				const type = el.data('show-date-type');
				if((type === 'date' || type === 'time') && (whichDate === 'pubDisplay' || whichDate === 'modDisplay')) {
					let dateParts = date.split(',');
					switch(type) {
						case 'date':
							date = dateParts.shift() + dateParts.shift();
							break;
						case 'time':
							date = dateParts.pop();
							break;
					}
				}

				el.html(date);
				return false;
			});
		});
	}

	function doClampImageCaptions(block) {
		block.find('div.tpl2024__image-caption[data-clamp-caption!=""]').each(function() {
			const caption = $(this);
			if(caption.find('.tpl2024__image-caption-show-more').length) return;
			const captionLines = parseInt(caption.data('clamp-caption') || 0);
			if(!captionLines || isNaN(captionLines)) return;
			const captionHeight = caption.height();
			const lineHeight = parseInt(caption.css('line-height') || '');
			if(captionHeight > (lineHeight * (captionLines + 1))) {
				const collapsedHeight = lineHeight * captionLines;
				caption.addClass('tpl2024__image-caption--clamped');
				caption.css('max-height', collapsedHeight + 'px');
				caption.append('<div class="tpl2024__image-caption-show-more"><span role="button"></span></div>');

				caption.find('.tpl2024__image-caption-show-more > span[role="button"]').on('click', function() {
					if(caption.is('.tpl2024__image-caption--expanded')) {
						caption.removeClass('tpl2024__image-caption--expanded');
						setTimeout(function() {
							caption.css('max-height', collapsedHeight + 'px');
						}, 0);
					} else {
						caption.one('transitionend', function() {
							caption.addClass('tpl2024__image-caption--expanded');
						});
						caption.css('max-height', captionHeight + 'px');
					}
				});
			}
		});
	}

	function doRelatedArticles(block) {
		block.find('ul.tpl2024__related[data-fetch-related]').each(function() {
			const relatedUl = $(this);
			const maxRelatedCount = parseInt(relatedUl.attr('data-fetch-related'));
			if(!maxRelatedCount) return;

			const article = relatedUl.closest('article');
			const blockItems = tpl2024.getBlockItems(article);
			if(!blockItems) return;

			const blockItemRelated = blockItems.related || [];
			if(!blockItems.topic && !blockItemRelated.length) return;

			const showDate = relatedUl.is('[data-show-related-date="true"]');

			const appendLi = function(headline, href, modified) {
				const html = [];

				if(showDate) {
					html.push($('<span/>', {
						class: 'tpl2024__related-modified',
						html : modified
					}));
				}

				html.push($('<a/>', {
					href: href,
					html: headline
				}));

				$('<li/>').html(html).appendTo(relatedUl);
			};

			let blockItemCount = 0;

			blockItemRelated.forEach(function(related) {
				if(++blockItemCount > maxRelatedCount) return;
				appendLi(related.headline, related.href, related.modified);
			});

			if(blockItemCount < maxRelatedCount && blockItems.topic) {
				const feedPath = blockItems.topic.match('/') ? blockItems.topic : 'topic/' + blockItems.topic;
				const json = $.getJSON('/smi/feeds/json?feed_path=' + feedPath + '&ipp=' + maxRelatedCount);
				json.done(function(data) {
					if(!data.stories || !data.stories.length) return;
					data.stories.forEach(function(story) {
						if(++blockItemCount > maxRelatedCount) return;
						appendLi(story.headline, story.href, story.dates.modDisplay);
					});
				});
			}
		});
	}

	tpl2024.getStoryObject = function(jqArticleObj) {
		const articleKey = jqArticleObj.data('article-key');
		return tpl2024.articles[articleKey] || {};
	};

	tpl2024.getBlockItems = function(jqArticleObj) {
		const story = tpl2024.getStoryObject(jqArticleObj);
		return story.block || {};
	};

	tpl2024.buildArticles = function(block) {
		doImageGalleries(block);
		doArticleLabels(block);
		doDateUpdated(block);
		doClampImageCaptions(block);
		doRelatedArticles(block);
	};

	$(document).on('click', '.tpl2024__video-overlay', function() {
		const overlays = $('.tpl2024__video-overlay');
		const parents = overlays.closest('article');
		parents.removeClass('tpl2024--video-is-playing');
		parents.find('iframe').attr('src', '');

		const parent = $(this).closest('article');
		const iframe = parent.find('iframe');
		const src = iframe.attr('data-src');
		parent.addClass('tpl2024--video-is-playing');
		iframe.attr('src', src);
	});

	/**
	 * tpl2024Article available options w/ defaults
	 * to be entered as {{tpl2024Article 'nope' imageRatio='16:9' allowVideo='true' ...}}
	 *
	 * class             = false,
	 * imageRatio        = '4:3'
	 * imageMaxHeight    = 'none'
	 * imageCount        = '1'
	 * allowVideo        = false
	 * hideHeadline      = false
	 * showExcerpt       = false
	 * unwrapCopy        = false
	 * imageSize         = 'medium'
	 * imageSizes        = false
	 * showImageCaptions = false
	 * showBlockLabel    = false
	 * showBlockRelated  = false
	 */
	Template7.registerHelper('tpl2024Article', function(doNotUse, options) {
		return buildArticle(this, options);
	});

	Template7.registerHelper('tpl2024Profile', function(doNotUse, options) {
		return buildProfile(this, options);
	});
})(jQuery);


